// extracted by mini-css-extract-plugin
export default {"starterScreen":"Vj","starterImage":"Wj","already":"Xj","starterImageMobile":"Yj","controlX":"Zj","starterTextContain":"ak","starterHeader":"bk","starterBtn":"ck","starterSecondaryBtn":"ek","starterBanner":"fk","mobileBtnContainer":"gk"};
    if(module.hot) {
      // 1713912562382
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  